import React from 'react';
import { Card, Typography } from 'antd';
import PartnerPushSettings from './PartnerPushSettings';
export default function SubmissionSettings() {
  return <div><div className="page-header"><Typography.Title level={2}>报名提交</Typography.Title>
    <div className="description">配置报名提交接口与自动提交方式，岗位查询参数在系统设置中管理。</div></div>
    <Card><PartnerPushSettings /></Card></div>;
}
